import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "passPage page"
  }, [_c('m-head'), _c('div', {
    staticClass: "passPage-bg",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/pass/pass-bg.jpg`)}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "passPage-main page-main"
  }, [_c('div', {
    staticClass: "passPage-head"
  }, [_c('div', {
    staticClass: "passPage-head__title"
  }, [_vm._v("FanPoints")]), _c('div', {
    staticClass: "passPage-head__img",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/icon-coin.png`)}) center/auto 100% no-repeat`
    }
  })]), _c('div', {
    staticClass: "passPage-total"
  }, [_c('div', {
    staticClass: "passPage-total__value"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.total_coin, 2, false)))]), _c('div', {
    staticClass: "passPage-total-progress"
  }, _vm._l(5, function (_, index) {
    return _c('div', {
      staticClass: "passPage-total-progress-item"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/pass/${_vm.userInfo.total_coin / _vm.settingInfo.max_total_coin * 100 >= (index + 1) * 20 ? 'passStar-active' : 'passStar'}.png`),
        "alt": ""
      }
    })]);
  }), 0)]), _vm._m(0), _c('div', {
    staticClass: "passPage-way"
  }, [_c('div', {
    staticClass: "passPage-way-main"
  }, [_c('div', {
    staticClass: "passPage-way__title"
  }, [_vm._v("Ways to Earn FanPoints")]), _c('div', {
    staticClass: "passPage-way-list"
  }, _vm._l(_vm.wayList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "passPage-way-item",
      on: {
        "click": () => _vm.$router.push(item.path)
      }
    }, [_c('div', {
      staticClass: "passPage-way-item-main"
    }, [_c('span', [_c('img', {
      staticClass: "passPage-way-item__icon",
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/pass/${item.icon}.png`),
        "alt": ""
      }
    }), _vm._v(_vm._s(item.name)), _c('img', {
      staticClass: "passPage-way-item__num",
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/pass/pass-way-num${index + 1}.png`),
        "alt": ""
      }
    })])])]);
  }), 0)])])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "passPage-intro"
  }, [_c('div', {
    staticClass: "passPage-intro__label"
  }, [_vm._v("FanPoints are your key to Rewards!")]), _c('div', {
    staticClass: "passPage-intro__more"
  }, [_vm._v("Use them to qualify for future Token Airdrops, unlock Exclusive Paolo Maldini Merch, and enjoy more Fan Perks.")])]);
}];
export { render, staticRenderFns };